import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { Injectable } from '@angular/core';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { WhatComponent } from './what/what.component';

import { RoutesGuard } from './guards/routes.guard';
import { HowComponent } from './how/how.component';
import { Globals } from './globals';

import { HttpClientModule }    from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotfoundComponent } from './notfound/notfound.component';

const appRoutes: Routes = [
  { path: '', canActivate: [RoutesGuard], component: HomeComponent },
  { path: 'home', canActivate: [RoutesGuard], component: HomeComponent, data: { title: 'List' } },
  { path: 'home/:contact', canActivate: [RoutesGuard], component: HomeComponent, data: { title: 'List' } },
  { path: 'what', canActivate: [RoutesGuard], component: WhatComponent, data: { title: 'what List' } },
  { path: 'how', canActivate: [RoutesGuard], component: HowComponent, data: { title: 'how List' } },
  {path: '404', component: NotfoundComponent},
  {path: '**', redirectTo: '/404'}
  // { path: '',
  //   redirectTo: '/heroes',
  //   pathMatch: 'full'
  // },
  // { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    ),
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  declarations: [
    AppComponent,
    HomeComponent,
    WhatComponent,
    HowComponent,
    NotfoundComponent
  ],
  providers: [
    RoutesGuard, 
    Globals,
    {provide: 'googleTagManagerId', useValue: 'GTM-NL3QS3W'}
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }